import {FETCH_ALL_ADMIN_LEAGUES_BEGIN, FETCH_ALL_ADMIN_LEAGUES_SUCCESS, FETCH_ALL_ADMIN_LEAGUES_FAILURE,
  FETCH_LEAGUE_SEASONS_BEGIN, FETCH_LEAGUE_SEASONS_SUCCESS, FETCH_LEAGUE_SEASONS_FAILURE} from '../constants/action-types';
import {BASE_URL, API_URLS} from '../constants/config'
import {refreshTokens, logOut} from './usersActions'
import {checkIfTokenExpired, getTokensFromStore } from '../utilities/tokens'
import { bumpLeagueLogoCache } from '../utilities/leagueStructure'
import axios from 'axios';

// Общее для запросов раздела "Управление лигами": обновить протухший токен,
// подставить заголовки, разлогинить при 401
const authorizedTokens = async (dispatch) => {
  if (checkIfTokenExpired()) {
    await dispatch(refreshTokens());
  }
  return getTokensFromStore();
};

const authHeaders = (tokens) => ({
  headers: {
    "Authorization": "Bearer " + tokens.access_token,
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

const handleAuthError = (dispatch, error) => {
  if (error.response && error.response.status === 401) {
    dispatch(logOut());
  }
  throw error;
};

export const fetchAllAdminLeaguesBegin = () => ({
  type: FETCH_ALL_ADMIN_LEAGUES_BEGIN
});

export const fetchAllAdminLeaguesSuccess = leaguesData => ({
  type: FETCH_ALL_ADMIN_LEAGUES_SUCCESS,
  payload: { leaguesData }
});

export const fetchAllAdminLeaguesFailure = error => ({
  type: FETCH_ALL_ADMIN_LEAGUES_FAILURE,
  payload: { error }
});

export const fetchLeagueSeasonsBegin = () => ({
  type: FETCH_LEAGUE_SEASONS_BEGIN
});

export const fetchLeagueSeasonsSuccess = seasonsData => ({
  type: FETCH_LEAGUE_SEASONS_SUCCESS,
  payload: { seasonsData }
});

export const fetchLeagueSeasonsFailure = error => ({
  type: FETCH_LEAGUE_SEASONS_FAILURE,
  payload: { error }
});

export function fetchAllAdminLeagues() {
  let url = API_URLS.getAllAdminLeagues
  return async dispatch => {
    const isTokenExpired = checkIfTokenExpired();
    if(isTokenExpired){
      await dispatch(refreshTokens())
    }
    const tokens = getTokensFromStore();
    dispatch(fetchAllAdminLeaguesBegin());
    return axios.get(BASE_URL.url + url,
      {          
        headers: {
        "Authorization" : "Bearer " + tokens.access_token,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
      }).then(res => {
      dispatch(fetchAllAdminLeaguesSuccess(res));
      return res;
    })
        .catch((error) => {
          dispatch(fetchAllAdminLeaguesFailure(error.response))
          if(error.response.status == 401) {
            dispatch(logOut())
          }
        });
  };
}

// Чемпионаты и лиги текущего админа — один рут вместо /championships/all + /adminLeagues
export function fetchAdminLeagueStructure() {
  return async dispatch => {
    const tokens = await authorizedTokens(dispatch);
    return axios.post(BASE_URL.url + API_URLS.getAdminLeagueStructure, {}, authHeaders(tokens))
      .then(res => res.data)
      .catch(error => handleAuthError(dispatch, error));
  };
}

// Логотипы клиентов: { [client_id]: '/images/...' } для галочки
// «Использовать основной лого». Никогда не падает: без логотипа
// галочка просто не показывается
export function fetchAdminClientImages() {
  return async dispatch => {
    const tokens = await authorizedTokens(dispatch);
    const res = await axios.post(BASE_URL.url + API_URLS.getAdminClients, {}, authHeaders(tokens))
      .catch(() => null);
    const data = res && res.data;
    let rows = [];
    if (Array.isArray(data)) rows = data;
    else if (data && Array.isArray(data.data)) rows = data.data;
    else if (data && Array.isArray(data.clients)) rows = data.clients;
    const map = {};
    rows.forEach(client => {
      const id = Number(client.id !== undefined ? client.id : client.client_id);
      const image = client.image || client.client_image || client.logo;
      if (!isNaN(id) && image) map[id] = image;
    });
    return map;
  };
}

// Команды-участницы лиги в конкретном сезоне (related_leagues + teams)
export function fetchLeagueTeams(league_id, season_id) {
  return async dispatch => {
    return axios.post(BASE_URL.url + `/leagues/${league_id}/teams`,
      { season_id: Number(season_id) },
      {
        headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
      }).then(res => res.data);
  };
}

// Команды сезона с разбивкой по группам (league_groups). Требует авторизации.
export function fetchLeagueTeamsByGroups(league_id, season_id) {
  return async dispatch => {
    const isTokenExpired = checkIfTokenExpired();
    if(isTokenExpired){
      await dispatch(refreshTokens())
    }
    const tokens = getTokensFromStore();
    return axios.post(BASE_URL.url + `/leagues/${league_id}/teamsByGroups`,
      { season_id: Number(season_id) },
      {
        headers: {
        "Authorization" : "Bearer " + tokens.access_token,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
      }).then(res => res.data)
        .catch((error) => {
          if(error.response && error.response.status == 401) {
            dispatch(logOut())
          }
          throw error;
        });
  };
}

// Все команды клиента - справочник для добавления команды в сезон.
// Бэкенд игнорирует тело запроса и отдаёт команды по client_id из токена.
export function fetchAdminTeamsList() {
  return async dispatch => {
    const isTokenExpired = checkIfTokenExpired();
    if(isTokenExpired){
      await dispatch(refreshTokens())
    }
    const tokens = getTokensFromStore();
    return axios.post(BASE_URL.url + API_URLS.getAdminTeams,
      {},
      {
        headers: {
        "Authorization" : "Bearer " + tokens.access_token,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
      }).then(res => res.data)
        .catch((error) => {
          if(error.response && error.response.status == 401) {
            dispatch(logOut())
          }
          throw error;
        });
  };
}

// Справочник всех сезонов
export function fetchAllSeasons() {
  return async dispatch => {
    const tokens = await authorizedTokens(dispatch);
    return axios.get(BASE_URL.url + API_URLS.getAllSeasons, authHeaders(tokens))
      .then(res => res.data)
      .catch(error => handleAuthError(dispatch, error));
  };
}

// Справочник заявок клиента (team_applications_ex)
export function fetchApplicationTemplates() {
  return async dispatch => {
    const tokens = await authorizedTokens(dispatch);
    return axios.post(BASE_URL.url + API_URLS.getApplicationTemplates, {}, authHeaders(tokens))
      .then(res => res.data)
      .catch(error => handleAuthError(dispatch, error));
  };
}

// Спонсоры лиги для заставки жеребьёвки: league_partners через related_partners.
// Пока рута нет, ошибка гасится — жеребьёвка идёт без полосы спонсоров.
export function fetchLeaguePartners(league_id, season_id) {
  return async dispatch => {
    const tokens = await authorizedTokens(dispatch);
    const url = API_URLS.getLeaguePartners.replace(':leagueId', league_id);
    return axios.post(BASE_URL.url + url, { season_id: Number(season_id) }, authHeaders(tokens))
      .then(res => res.data)
      .catch(error => handleAuthError(dispatch, error));
  };
}

// ---- Запись ----

const postAuthorized = (url, body) => async dispatch => {
  const tokens = await authorizedTokens(dispatch);
  return axios.post(BASE_URL.url + url, body, authHeaders(tokens))
    .then(res => res.data)
    .catch(error => handleAuthError(dispatch, error));
};

export const createChampionat = (data) =>
  postAuthorized(API_URLS.createChampionat, data);

export const updateChampionat = (data) =>
  postAuthorized(API_URLS.updateChampionat, data);

// Если выбран логотип — multipart (поля + файл `logo`), иначе обычный JSON.
// Файл не грузим заранее: без созданной лиги он на сервере не нужен.
export const createLeague = (data) => {
  const { logoFile, ...fields } = data;
  if (!logoFile) {
    return postAuthorized(API_URLS.createLeague, { ...fields, image: fields.image || '' });
  }
  return async dispatch => {
    const tokens = await authorizedTokens(dispatch);
    const form = new FormData();
    form.append('name', fields.name);
    form.append('championat_id', String(fields.championat_id));
    form.append('league_type', String(fields.league_type ?? 1));
    form.append('priority', String(fields.priority));
    form.append('enabled', String(fields.enabled));
    form.append('active_season', fields.active_season == null ? '' : String(fields.active_season));
    form.append('logo', logoFile);
    return axios.post(BASE_URL.url + API_URLS.createLeague, form, {
      headers: {
        "Authorization": "Bearer " + tokens.access_token,
        Accept: 'application/json',
      },
    }).then(res => res.data)
      .catch(error => handleAuthError(dispatch, error));
  };
};

export const createLeagueSeason = (data) =>
  postAuthorized(API_URLS.createLeagueSeason, data);

export const updateLeagueSettings = (data) =>
  postAuthorized(API_URLS.updateLeagueSettings, data);

export const setSeasonTeams = (data) =>
  postAuthorized(API_URLS.setSeasonTeams, data);

export const setSeasonGroups = (data) =>
  postAuthorized(API_URLS.setSeasonGroups, data);

export const createApplicationTemplate = (data) =>
  postAuthorized(API_URLS.createApplicationTemplate, data);

// Как createLeague: новый файл — multipart с полем `logo` на этот же рут.
// Если лого не меняли — JSON с текущим путём в `image`.
export const updateLeague = (data) => {
  const { logoFile, ...fields } = data;
  if (!logoFile) {
    return postAuthorized(API_URLS.updateLeague, {
      ...fields,
      image: fields.image || '',
    });
  }
  return async dispatch => {
    const tokens = await authorizedTokens(dispatch);
    const form = new FormData();
    form.append('league_id', String(fields.league_id));
    form.append('name', fields.name);
    form.append('championat_id', String(fields.championat_id));
    form.append('priority', String(fields.priority));
    form.append('enabled', String(fields.enabled));
    form.append('active_season', fields.active_season == null ? '' : String(fields.active_season));
    form.append('logo', logoFile);
    return axios.post(BASE_URL.url + API_URLS.updateLeague, form, {
      headers: {
        "Authorization": "Bearer " + tokens.access_token,
        Accept: 'application/json',
      },
    }).then(res => {
      bumpLeagueLogoCache(fields.league_id);
      return res.data;
    })
      .catch(error => handleAuthError(dispatch, error));
  };
};

export function fetchLeagueSeasons(league_id) {
  let url = `${API_URLS.getLeagueSeasons}/${league_id}/adminLeagues`
  return async dispatch => {
    const isTokenExpired = checkIfTokenExpired();
    if(isTokenExpired){
      await dispatch(refreshTokens())
    }
    const tokens = getTokensFromStore();
    dispatch(fetchLeagueSeasonsBegin());
    return axios.post(BASE_URL.url + url,
      {},
      {          
        headers: {
        "Authorization" : "Bearer " + tokens.access_token,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
      }).then(res => {
      dispatch(fetchLeagueSeasonsSuccess(res));
      return res;
    })
        .catch((error) => {
          dispatch(fetchLeagueSeasonsFailure(error.response))
          if(error.response.status == 401) {
            dispatch(logOut())
          }
        });
  };
}

